// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ContestPosts__list":"th_a bik_rc bik_qx bik_xr","ContestPosts__more":"th_b bik_vu bik_b bik_va bik_sv"};